import type { TurnRoute } from "../hosting/routeChoices";
import type { LlmChoice } from "./LlmPicker";
import { withStepRoute } from "./stepRoutes";

/**
 * The LLMs a start chooses before it runs (F106, TR-A2-04): the PC, the Thread's default
 * route on it and agent steps' own. The start sends the routes (`StartThreadBody.routes`) and
 * goes live on the PC, so the first agent step already runs on them.
 */
export interface StartRouteDraft {
  readonly connectorId: string;
  readonly route: TurnRoute;
  readonly stepRoutes: Readonly<Record<string, TurnRoute>>;
}

/** What the start sends: the routes, as the server's `StartRoutes` takes them. */
export function startRoutesOf(draft: StartRouteDraft): { readonly route: TurnRoute; readonly step_routes: Readonly<Record<string, TurnRoute>> } {
  return { route: draft.route, step_routes: draft.stepRoutes };
}

/**
 * The Thread's default chosen. A step's own LLM stays, also on another PC: the step's row says
 * when that PC doesn't offer it, and the person chooses again; nothing is dropped unasked.
 */
export function draftWithDefault(draft: StartRouteDraft | null, choice: LlmChoice): StartRouteDraft {
  return { connectorId: choice.connectorId, route: choice.route, stepRoutes: draft?.stepRoutes ?? {} };
}

/** A step's own route, or `null` to take it off so the step runs on the Thread's default. */
export function draftWithStepRoute(draft: StartRouteDraft, stepKey: string, route: TurnRoute | null): StartRouteDraft {
  return { ...draft, stepRoutes: withStepRoute(draft.stepRoutes, stepKey, route) };
}
